// extracted by mini-css-extract-plugin
export default {"galleryoverview":"Gallery_galleryoverview__39dd+"};